var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPageNotFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 400 300"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#PageNotFound_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M384.171 163.633c-6.683 13.785-20.251 23.003-34.313 29.082-18.93 8.186-39.777 11.433-60.338 10.06q-5.404-.36-10.777-1.15a136 136 0 0 1-36.032-10.492 130 130 0 0 1-9.729-4.882 124.5 124.5 0 0 1-18.792-12.791c-.817-.674-1.627-1.364-2.449-2.033-1.736-1.411-3.521-2.751-5.513-3.755a20 20 0 0 0-1.846-.814c-6.308-2.4-13.582-1.494-20.148.377-4.995 1.423-9.864 3.373-14.854 4.763a49 49 0 0 1-6.768 1.439 36 36 0 0 1-15.206-1.336l-.42-.13a39 39 0 0 1-2.095-.727l-.42-.161a32 32 0 0 1-1.969-.833l-.42-.191a37 37 0 0 1-1.969-.988c-.232-.121-.461-.252-.687-.375a41.2 41.2 0 0 1-9.849-7.668c-.083-.083-.161-.169-.251-.252q-.602-.647-1.172-1.323-.212-.248-.42-.503a37 37 0 0 1-1.306-1.687q-.094-.126-.183-.252a36.4 36.4 0 0 1-4.241-7.668 40 40 0 0 1-1.016-2.885 28 28 0 0 1-.317-1.127 10 10 0 0 1-.09-.334c-1.388-5.465-1.547-11.147-1.547-16.795v-1.975c.04-9.137.181-18.43 1.529-27.441 0-.063.018-.126.028-.186a86 86 0 0 1 1.838-9.01 66.6 66.6 0 0 1 3.096-9.129c3.101-7.293 7.611-13.93 12.618-20.082 12.613-15.48 29.154-28.475 48.515-33.34 20.862-5.238 44.048-.218 60.876 13.18 5.131 4.084 9.741 8.92 15.503 12.051 5.03 2.727 10.918 3.856 16.305 1.71 4.452-1.772 7.349-2.653 12.349-2.384a103.5 103.5 0 0 1 30.271 6.34q.588.217 1.174.44c25.329 9.691 47.102 28.944 58.419 53.684q.45.981.873 1.977c6.748 15.762 9.187 34.235 1.743 49.596",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#PageNotFound_svg__b)",
  d: "M365.698 52.1H132.97a3.14 3.14 0 0 0-3.141 3.14v129.11a3.14 3.14 0 0 0 3.141 3.141h232.728a3.14 3.14 0 0 0 3.141-3.141V55.24a3.14 3.14 0 0 0-3.141-3.14"
}), /*#__PURE__*/React.createElement("use", {
  href: "#PageNotFound_svg__c"
}), /*#__PURE__*/React.createElement("use", {
  href: "#PageNotFound_svg__c"
}), /*#__PURE__*/React.createElement("use", {
  href: "#PageNotFound_svg__c",
  opacity: 0.04
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a5773",
  d: "M367.277 52.477H131.418a1.21 1.21 0 0 0-1.21 1.21v5.112h238.269v-5.113a1.21 1.21 0 0 0-1.2-1.21"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M134.967 57.273a1.635 1.635 0 1 0 0-3.27 1.635 1.635 0 0 0 0 3.27m4.401 0a1.635 1.635 0 1 0 0-3.27 1.635 1.635 0 0 0 0 3.27m4.401 0a1.635 1.635 0 1 0 0-3.27 1.635 1.635 0 0 0 0 3.27"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M213.778 70.69h-63.945v5.428h63.945z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a5773",
  d: "M348.862 92.453H149.833v83.489h199.029zm0-8.035h-20.145v4.755h20.145z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M358.877 224.655c12.262 0 22.203-1.596 22.203-3.566s-9.941-3.566-22.203-3.566-22.202 1.596-22.202 3.566 9.94 3.566 22.202 3.566",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#535461",
  d: "M359.592 152.776h-1.429v32.167h1.429z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m368.57 184.845-.09 1.449-.126 2.045-.053.852-.126 2.047-.055.853-.126 2.045-1.441 23.256a3.935 3.935 0 0 1-3.931 3.697h-7.49a3.936 3.936 0 0 1-3.928-3.697l-1.449-23.256-.125-2.045-.053-.853-.124-2.052-.052-.853-.126-2.044-.091-1.449a2.04 2.04 0 0 1 2.038-2.165h15.314a2.04 2.04 0 0 1 2.034 2.17"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9d9cb5",
  d: "m368.48 186.294-.126 2.044h-18.956l-.126-2.044zm-.179 2.897-.126 2.047h-18.596l-.128-2.047zm-.181 2.9-.126 2.045H349.76l-.128-2.045z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M347.092 164.833c8.32 6.018 11.785 15.435 11.785 15.435s-10.027-.345-18.359-6.363-11.786-15.435-11.786-15.435 10.038.345 18.36 6.363"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 0.553,
  d: "M328.745 158.47s10.407 5.785 13.744 10.563c3.338 4.779 16.388 11.237 16.388 11.237"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M352.461 152.718c4.527 3.27 6.416 8.4 6.416 8.4s-5.457-.186-9.987-3.463c-4.529-3.277-6.413-8.4-6.413-8.4s5.457.174 9.984 3.463"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 0.553,
  d: "M342.477 149.242s5.664 3.144 7.479 5.747 8.921 6.117 8.921 6.117"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M365.459 160.847c-5.203 5.716-6.303 13.186-6.303 13.186s7.334-1.798 12.535-7.515 6.303-13.189 6.303-13.189-7.334 1.798-12.535 7.518"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 0.553,
  d: "M377.994 153.329s-6.775 5.86-8.498 9.899-10.34 10.815-10.34 10.815"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#PageNotFound_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M251.787 157.65c29.628 0 53.646-1.59 53.646-3.552s-24.018-3.551-53.646-3.551-53.647 1.59-53.647 3.551 24.019 3.552 53.647 3.552"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M249.731 115.219c-8.741 0-15.016 5.607-15.016 18.692 0 14.829 6.275 18.754 15.016 18.754s15.39-4.299 15.39-18.754c0-15.453-6.65-18.692-15.39-18.692m.057 32.524c-6.054 0-9.216-3.552-9.216-13.823 0-9.062 3.292-13.842 9.346-13.842s9.346 3.14 9.346 13.842c0 10.012-3.422 13.823-9.476 13.823"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M229.481 142.322h-3.614V131.68a2.13 2.13 0 0 0-2.131-2.131h-.847a2.127 2.127 0 0 0-2.131 2.131v10.642h-10.193a1.22 1.22 0 0 1-1.043-.588 1.22 1.22 0 0 1-.033-1.197l10.788-20.419a2.133 2.133 0 0 0-.974-2.923l-.637-.301a2.13 2.13 0 0 0-2.789.923l-13.158 24.615a2.88 2.88 0 0 0-.122 2.468c.145.35.358.669.627.937a2.88 2.88 0 0 0 2.043.847h15.491v6.729c0 .335.066.668.194.978a2.57 2.57 0 0 0 1.383 1.382 2.563 2.563 0 0 0 3.338-1.382c.128-.31.194-.643.194-.978v-6.729h3.614a2.182 2.182 0 0 0 0-4.362m66.918 0h-3.614V131.68a2.13 2.13 0 0 0-2.131-2.131h-.847a2.127 2.127 0 0 0-2.131 2.131v10.642h-10.193a1.22 1.22 0 0 1-1.043-.588 1.22 1.22 0 0 1-.033-1.197l10.788-20.419a2.133 2.133 0 0 0-.974-2.923l-.637-.301a2.13 2.13 0 0 0-2.789.923l-13.158 24.615a2.89 2.89 0 0 0 2.548 4.252h15.491v6.729a2.555 2.555 0 0 0 5.109 0v-6.729h3.614a2.182 2.182 0 0 0 0-4.362"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M230.478 141.076h-3.614v-10.642a2.13 2.13 0 0 0-1.316-1.969 2.1 2.1 0 0 0-.815-.162h-.847a2.13 2.13 0 0 0-2.131 2.131v10.642h-10.194a1.22 1.22 0 0 1-1.216-1.182c-.006-.21.043-.418.141-.603l10.788-20.419a2.133 2.133 0 0 0-.974-2.923l-.637-.301a2.13 2.13 0 0 0-2.789.923l-13.159 24.614a2.89 2.89 0 0 0 2.549 4.252h15.491v6.73a2.56 2.56 0 0 0 .748 1.806 2.57 2.57 0 0 0 1.806.748 2.555 2.555 0 0 0 2.555-2.554v-6.73h3.614a2.18 2.18 0 0 0 2.181-2.18 2.2 2.2 0 0 0-.639-1.542 2.18 2.18 0 0 0-1.542-.639Zm67.79 0h-3.614v-10.642a2.13 2.13 0 0 0-2.131-2.131h-.847a2.13 2.13 0 0 0-1.969 1.316 2.1 2.1 0 0 0-.162.815v10.642h-10.193a1.22 1.22 0 0 1-1.042-.589 1.21 1.21 0 0 1-.034-1.196l10.788-20.419a2.126 2.126 0 0 0-.974-2.923l-.637-.301a2.13 2.13 0 0 0-2.789.923l-13.158 24.614a2.89 2.89 0 0 0 .505 3.406 2.9 2.9 0 0 0 2.043.846h15.491v6.73a2.555 2.555 0 0 0 2.555 2.554 2.555 2.555 0 0 0 2.554-2.554v-6.73h3.614a2.18 2.18 0 0 0 2.181-2.18 2.18 2.18 0 0 0-2.181-2.181Zm-46.543-26.979c-8.741 0-15.016 5.608-15.016 18.692 0 14.829 6.275 18.755 15.016 18.755s15.389-4.3 15.389-18.755c0-15.452-6.649-18.692-15.389-18.692Zm.057 32.524c-6.054 0-9.217-3.551-9.217-13.822 0-9.063 3.293-13.842 9.347-13.842s9.346 3.139 9.346 13.842c0 10.012-3.422 13.822-9.476 13.822Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M299.201 140.902c.308.112.638.151.964.113a2.1 2.1 0 0 0 1.584-1.029 2.13 2.13 0 0 0 .131-1.884 2.12 2.12 0 0 0-2.397-1.26l.053 1.09-.515-.934a2.11 2.11 0 0 0-1.209 1.765 2.12 2.12 0 0 0 1.389 2.139"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M301.752 153.537c-.182-.926.606-1.748 1.385-2.281s1.689-1.059 1.954-1.965c.382-1.302-.755-2.495-1.641-3.523a12.7 12.7 0 0 1-1.68-2.498c-.184-.359-.354-.734-.402-1.135-.07-.577.116-1.152.302-1.702a123 123 0 0 1 1.997-5.456"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M299.288 140.621a2.12 2.12 0 0 0 1.877-.214 2.115 2.115 0 0 0 .234-3.373 2.11 2.11 0 0 0-1.829-.472l.053 1.089-.515-.933a2.1 2.1 0 0 0-1.208 1.764 2.114 2.114 0 0 0 1.388 2.139Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M301.493 134.6a2.12 2.12 0 0 1 1.523-1.342l.175 1.036.323-1.088a2.12 2.12 0 0 1 1.994 1.502 2.117 2.117 0 1 1-4.015-.108"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M301.609 134.226a2.12 2.12 0 0 1 1.524-1.342l.174 1.036.323-1.088a2.12 2.12 0 0 1 1.967 2.814 2.11 2.11 0 0 1-2.055 1.418 2.115 2.115 0 0 1-1.933-2.838Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M303.079 145.789a2.118 2.118 0 0 0 2.763-2.548 2.1 2.1 0 0 0-.89-1.217l-.248.835-.176-1.047-.006-.002a2.12 2.12 0 0 0-1.619.071 2.1 2.1 0 0 0-1.093 1.196 2.12 2.12 0 0 0 .072 1.619 2.12 2.12 0 0 0 1.197 1.093"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M303.18 145.41a2.116 2.116 0 0 0 1.873-3.765l-.249.836-.176-1.048-.005-.002a2.13 2.13 0 0 0-1.619.071 2.115 2.115 0 0 0-1.218 2.013 2.1 2.1 0 0 0 .687 1.468c.205.187.445.332.707.427Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M300.875 149.304a2.12 2.12 0 0 0 2.013 1.748 2.118 2.118 0 0 0 1.985-3.016 2.115 2.115 0 0 0-3.59-.39l.943 1.42-1.288-.754c-.1.321-.122.661-.063.992"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M300.962 149.023a2.115 2.115 0 1 0 .408-1.657l.943 1.419-1.288-.753c-.1.321-.121.661-.063.991Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M197.72 146.058a1.4 1.4 0 0 0 1.233-.141 1.395 1.395 0 0 0 .526-1.699 1.39 1.39 0 0 0-1.574-.827l.035.716-.339-.614a1.388 1.388 0 0 0-.573 2.015c.165.254.408.447.692.55"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M199.395 154.36c-.119-.609.399-1.149.911-1.5.511-.35 1.109-.695 1.284-1.29.251-.856-.497-1.639-1.079-2.315a8.4 8.4 0 0 1-1.104-1.641 2.3 2.3 0 0 1-.264-.746c-.046-.379.076-.757.199-1.118q.613-1.808 1.312-3.585"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M197.777 145.874a1.39 1.39 0 0 0 1.862-1.211 1.4 1.4 0 0 0-.475-1.146 1.39 1.39 0 0 0-1.202-.311l.035.716-.339-.613a1.38 1.38 0 0 0-.793 1.159 1.39 1.39 0 0 0 .912 1.406Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M199.225 141.918a1.39 1.39 0 0 1 1.001-.882l.115.68.212-.714a1.388 1.388 0 0 1 1.292 1.849c-.097.278-.28.518-.523.685a1.385 1.385 0 0 1-1.639-.043 1.39 1.39 0 0 1-.458-1.575"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M199.302 141.672a1.38 1.38 0 0 1 1.001-.882l.114.681.212-.715c.295.004.581.102.816.28a1.388 1.388 0 0 1-.873 2.5 1.392 1.392 0 0 1-1.27-1.864Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M200.267 149.269a1.39 1.39 0 0 0 1.231-2.474l-.163.549-.116-.688-.003-.002a1.4 1.4 0 0 0-1.064.047 1.4 1.4 0 0 0-.719.786 1.4 1.4 0 0 0 .048 1.064 1.4 1.4 0 0 0 .786.718"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M200.333 149.02a1.393 1.393 0 0 0 1.72-.688 1.39 1.39 0 0 0-.489-1.786l-.163.549-.116-.688-.003-.002a1.39 1.39 0 1 0-.949 2.615Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#57b894",
  d: "M198.82 151.578a1.387 1.387 0 0 0 2.207.868 1.39 1.39 0 1 0-1.939-1.957l.619.933-.846-.495c-.066.211-.08.434-.041.651"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M198.877 151.394a1.386 1.386 0 0 0 1.322 1.148 1.39 1.39 0 0 0 1.396-1.057 1.388 1.388 0 0 0-2.45-1.18l.619.932-.846-.495c-.066.211-.08.435-.041.652Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M245.716 132.925c.954 0 1.729-1.002 1.729-2.237s-.775-2.238-1.729-2.238-1.729 1.002-1.729 2.238.774 2.237 1.729 2.237m9.407.051c.955 0 1.729-1.002 1.729-2.237s-.774-2.238-1.729-2.238-1.729 1.002-1.729 2.238.774 2.237 1.729 2.237m-1.322 4.373c0 1.011-1.412 1.831-3.153 1.831s-3.153-.82-3.153-1.831c0-.876 1.059-1.608 2.474-1.787q.338-.045.679-.044.573-.001 1.132.123c1.182.263 2.021.929 2.021 1.708"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 0.276,
  d: "M246.122 132.417c.955 0 1.729-1.002 1.729-2.238s-.774-2.237-1.729-2.237c-.954 0-1.728 1.001-1.728 2.237s.774 2.238 1.728 2.238Zm9.408.05c.955 0 1.729-1.001 1.729-2.237s-.774-2.237-1.729-2.237-1.729 1.001-1.729 2.237.774 2.237 1.729 2.237Zm-4.475 6.204c1.741 0 3.153-.819 3.153-1.83s-1.412-1.831-3.153-1.831-3.153.82-3.153 1.831 1.412 1.83 3.153 1.83Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M251.818 135.793a.5.5 0 0 1-.135.345.43.43 0 0 1-.323.143h-1.017a.476.476 0 0 1-.458-.488c0-.099.029-.196.084-.279q.338-.047.679-.046.574-.002 1.132.13a.5.5 0 0 1 .038.195m-5.696-5.715a.51.51 0 1 0 0-1.018.51.51 0 0 0 0 1.018m9.459 0a.509.509 0 1 0-.002-1.018.509.509 0 0 0 .002 1.018"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M256.089 134.857a.508.508 0 1 0 .001-1.017.508.508 0 0 0-.001 1.017m-12.407 0a.507.507 0 1 0 .001-1.015.507.507 0 0 0-.001 1.015",
  opacity: 0.3
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M75.801 213.477c24.179 0 43.779-19.601 43.779-43.78 0-24.178-19.6-43.779-43.779-43.779-24.178 0-43.78 19.601-43.78 43.779s19.602 43.78 43.78 43.78"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M12 119.199c0 19.491 12.228 35.263 27.339 35.263z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M39.339 154.462c0-19.71 13.645-35.659 30.508-35.659zm-17.434-33.496c0 18.514 7.798 33.496 17.434 33.496z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M39.339 154.462c0-25.185 15.771-45.564 35.262-45.564z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#a8a8a8",
  d: "M33.587 154.71s3.877-.119 5.046-.951c1.168-.832 5.963-1.826 6.253-.491s5.827 6.636 1.45 6.672-10.17-.682-11.337-1.392c-1.166-.711-1.412-3.838-1.412-3.838"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M46.414 159.475c-4.377.036-10.17-.682-11.337-1.392-.888-.541-1.242-2.482-1.36-3.378l-.13.005s.246 3.127 1.412 3.838c1.166.71 6.96 1.427 11.337 1.392 1.263-.01 1.7-.46 1.676-1.126-.176.403-.658.654-1.598.661",
  opacity: 0.2
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M61.95 219.498c25.975 0 47.032-2.865 47.032-6.398 0-3.534-21.057-6.399-47.031-6.399-25.975 0-47.031 2.865-47.031 6.399s21.056 6.398 47.03 6.398"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M61.95 218.471c21.808 0 39.487-2.405 39.487-5.372s-17.679-5.371-39.486-5.371c-21.808 0-39.486 2.405-39.486 5.371s17.678 5.372 39.486 5.372",
  opacity: 0.1
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M90.119 274.498c23.613 0 42.755-2.604 42.755-5.816 0-3.213-19.142-5.817-42.755-5.817s-42.755 2.604-42.755 5.817 19.142 5.816 42.755 5.816"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2f2e41",
  strokeMiterlimit: 10,
  strokeWidth: 0.553,
  d: "M133.446 236.667c31.946 14.115 93.354-18.411 100.098-55.232m-143.676-9.959s32.695-9.054 34.707 20.12-26.91 37.474-4.276 43.259m-62.019 6.61s9.826-2.721 10.43 6.047c.606 8.769-8.087 11.263-1.284 13.002"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M91.628 146.326H39.316v60.863h52.312z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M96.91 140.289H34.034v21.63H96.91zm0 25.654H34.034v21.629H96.91zm0 25.653H34.034v21.629H96.91z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M84.335 144.062H80.31v4.024h4.023z",
  opacity: 0.4
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M90.12 144.062h-4.025v4.024h4.024z",
  opacity: 0.8
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M95.904 144.062h-4.025v4.024h4.025z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M84.335 169.464H80.31v4.024h4.023z",
  opacity: 0.4
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M90.12 169.464h-4.025v4.024h4.024z",
  opacity: 0.8
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M95.904 169.464h-4.025v4.024h4.025z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M84.335 194.865H80.31v4.025h4.023z",
  opacity: 0.4
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M90.12 194.865h-4.025v4.025h4.024z",
  opacity: 0.8
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M95.904 194.865h-4.025v4.025h4.025z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M91.628 261.514c10.973 0 19.869-8.896 19.869-19.869s-8.896-19.869-19.869-19.869-19.869 8.896-19.869 19.869 8.896 19.869 19.869 19.869"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M88.61 257.238h-6.036v10.815h6.036zm12.072 0h-6.036v10.815h6.036z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M87.604 270.065c2.778 0 5.03-.845 5.03-1.886 0-1.042-2.252-1.887-5.03-1.887s-5.03.845-5.03 1.887c0 1.041 2.252 1.886 5.03 1.886m12.072-.252c2.778 0 5.03-.844 5.03-1.886s-2.252-1.886-5.03-1.886-5.03.844-5.03 1.886 2.252 1.886 5.03 1.886"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M92.131 243.405a6.79 6.79 0 1 0 0-13.58 6.79 6.79 0 0 0 0 13.58"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M92.131 238.878a2.263 2.263 0 1 0 0-4.526 2.263 2.263 0 0 0 0 4.526"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#084782",
  d: "M72.355 223.168c-1.605-7.185 3.524-14.445 11.454-16.216s15.66 2.618 17.264 9.803c1.605 7.185-3.651 9.835-11.581 11.606s-15.533 1.992-17.137-5.193"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M110.263 237.682c5.044-2.159 8.584-5.192 7.906-6.776s-5.316-1.117-10.36 1.042-8.584 5.193-7.906 6.776 5.316 1.117 10.36-1.042m-37.223 13.33c5.045-2.159 8.584-5.193 7.906-6.776s-5.316-1.117-10.36 1.042-8.583 5.192-7.906 6.776 5.316 1.117 10.36-1.042"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M103.197 247.43c0 1.944-5.007 5.784-10.563 5.784s-10.814-3.588-10.814-5.533c0-1.944 5.258-1.509 10.814-1.509s10.563-.687 10.563 1.258"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "PageNotFound_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M100.619 25h288.114v206.21H100.619z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "PageNotFound_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M196.804 98.234h109.265v59.416H196.804z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "PageNotFound_svg__b",
  x1: 249.333,
  x2: 249.333,
  y1: 187.491,
  y2: 52.099,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("path", {
  id: "PageNotFound_svg__c",
  fill: "#fff",
  d: "M365.346 54.003H133.35a3.14 3.14 0 0 0-3.142 3.141V183.9a3.14 3.14 0 0 0 3.142 3.142h231.996a3.14 3.14 0 0 0 3.141-3.142V57.144a3.14 3.14 0 0 0-3.141-3.14"
}))));
export default SvgPageNotFound;